import React, { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import useDataTableLocale from "hooks/datatable/useDataTableLocale";
import useDataTableColumns from "hooks/datatable/useDataTableColumns";
import useDataTableRows from "hooks/datatable/useDataTableRows";
import useDataTableStyles from "hooks/datatable/useDataTableStyles";
import useDataTableSlots from "hooks/datatable/useDataTableSlots";
import { dataTablePageSizeOptions, dataTableSlotProps } from "helpers/datatable";
import useDataTableInitialState from "hooks/datatable/useDataTableInitialState";

const DataTable = ({
    getRowId = () => {},
    density = "compact",
    className = "",
    height = "auto",
    rows = [],
    columns = [],
    isLoading = true,
    hasIterator = true,
    pagination = true,
    hasExport = false,
    checkboxSelection = false,
    disabled = false,
    sx = {},
    pageSize = 25,
    rowSelectionModel = [],
    onRowSelectionModelChange = () => {},
    sortModel = { fields: "", sort: "" },
    getRowClassName = () => {},
    isRowSelectable = null,
}) => {
    const tableLocale = useDataTableLocale();
    const tableColumns = useDataTableColumns(columns, className, hasIterator, checkboxSelection);
    const tableRows = useDataTableRows(rows, sortModel);
    const tableSx = useDataTableStyles(sx);
    const tableSlots = useDataTableSlots(hasExport, pagination,isLoading);
    const tableInitialState = useDataTableInitialState(pageSize);

    const tableHeight = useMemo(
        () => (!rows || rows.length === 0 || isLoading ? 250 : height),
        [rows, isLoading, height]
    );

    return (
        <div className="w-100" style={{ maxWidth: "100%", height: tableHeight }}>
            <DataGrid
                checkboxSelection={disabled ? false : checkboxSelection}
                onRowSelectionModelChange={onRowSelectionModelChange}
                rowSelectionModel={rowSelectionModel}
                isRowSelectable={isRowSelectable ?? null}
                getRowId={getRowId}
                getRowClassName={getRowClassName}
                rows={tableRows}
                columns={tableColumns}
                initialState={tableInitialState}
                slots={tableSlots}
                slotProps={dataTableSlotProps}
                disableRowSelectionOnClick
                loading={isLoading}
                getRowHeight={() => "auto"}
                density={density}
                pageSizeOptions={dataTablePageSizeOptions}
                localeText={tableLocale}
                sx={tableSx}
                disableColumnMenu={true}
                hideFooter={!pagination}
            />
        </div>
    );
};

export default DataTable;
